import React from "react";
import { useSelector } from "react-redux";

function RightSide() {
  const { subdomain } = useSelector((state) => state.global);
  return (
    <div
      className={`hidden lg:flex w-full ${
        subdomain === "ndovupay" || subdomain === "localhost"
          ? "login-ndovu-pic"
          : "login-pic"
      }  px-[3.19rem] py-[4.5rem] flex-col justify-between`}
    >
      <div className="flex flex-col justify-center items-center">
        <div className="typography_login_1">Seamless payment management</div>
        <div className="typography_login_2  mt-[.5rem]">
          The fastest way to manage payments across your departments
        </div>
      </div>
      <div className="typography-footer mb-[2rem] flex justify-center">
        Powered by Smart People Africa
      </div>
    </div>
  );
}

export default RightSide;
